import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = process.env.REACT_APP_SITE_URL.replace(/\/$/, "");

export default function SEO({ title, description, image, rawTitle = false }) {
  const { pathname } = useLocation();
  const fullTitle = !title
    ? "Comparateur de conciergerie Airbnb en Bretagne : devis gratuit · Bretagne Conciergerie"
    : rawTitle ? title : `${title} · Bretagne Conciergerie`;
  const desc = description || "Comparez les conciergeries Airbnb partout en Bretagne. Une seule demande de devis gratuite, nous vous rappelons.";
  const img = image ? (image.startsWith("/") ? SITE + image : image) : null;
  const url = SITE + pathname;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="Bretagne Conciergerie Comparateur" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {img && <meta name="twitter:image" content={img} />}
    </Helmet>
  );
}
